export const DEALS_STATE_STORAGE_KEY = 'at.dealsApp.state';
export const DEFAULT_SEARCH_FOR_NEW_TAB = 'defaultSearchForNewTab';
export const FPA_NAVIGATION_STORAGE_KEY = 'fpa-navigation';
export const LAST_VIEWED_ADVERT_ID = 'lastViewedAdvertId';
export const LS_SAVED_ADS = 'localStorageSavedAds';
export const PART_EX_MODEL_VIEWED_STORAGE_KEY = 'partExModalViewed';
export const PERSONALISED_NAV_NOTIFICATION_KEY = 'personalisedNavNotification';
export const PREVIOUS_LOCATION_KEY_STORAGE_KEY = 'plk';
export const PREVIOUS_PAGE_DATA_STORAGE_KEY = 'ppd';
export const PREVIOUS_SEARCH_RESULTS_STORAGE_KEY = 'psr';
export const PREVIOUS_SESSION_LOCATION_STORAGE_KEY = 'psl';
export const SAVED_ADS_IN_SESSION = 'sessionSavedAds';
